// extracted by mini-css-extract-plugin
module.exports = {"close":"modal_confirmation_header-module--close--2KBJ2","icon":"modal_confirmation_header-module--icon--3d_A9","title":"modal_confirmation_header-module--title--1eQst"};